document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion h3');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      toggleAccordion(header);
    });

    addToggleIcon(header);

    hideContent(header);
  });

  function addToggleIcon(header) {
    if (!header.querySelector('.accordion-icon')) {
      const icon = document.createElement('span');
      icon.className = 'accordion-icon';
      icon.textContent = '+';
      header.insertBefore(icon, header.firstChild);
    }
  }

  function toggleAccordion(header) {
    const content = getContent(header);
    const icon = header.querySelector('.accordion-icon');

    if (!content || !icon) return;

    if (content.classList.contains('open')) {
      hideContent(header);
    } else {
      showContent(header);
    }
  }

  function showContent(header) {
    const content = getContent(header);
    const icon = header.querySelector('.accordion-icon');

    if (content && icon) {
      content.classList.add('open');
      header.classList.add('active');
      icon.textContent = '−';
    }
  }

  function hideContent(header) {
    const content = getContent(header);
    const icon = header.querySelector('.accordion-icon');

    if (content && icon) {
      content.classList.remove('open');
      header.classList.remove('active');
      icon.textContent = '+';
    }
  }

  function getContent(header) {
    let nextElement = header.nextElementSibling;
    while (nextElement && nextElement.tagName !== 'DIV') {
      nextElement = nextElement.nextElementSibling;
    }
    return nextElement;
  }
});
